var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-sd2000',{attrs:{"settings":_vm.settings},model:{value:(_vm.treatedItemValue),callback:function ($$v) {_vm.treatedItemValue=$$v},expression:"treatedItemValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a10b8ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sd2000/import/components/TreatedInputSd2000.vue
// module id = null
// module chunks = 